// extracted by mini-css-extract-plugin
module.exports = {"reviewDataButton":"ReviewDataButton_reviewDataButton__1vxvo"};